import { map } from 'rxjs/operators/map';
import { UserSerializer } from '../../models';
import ajax from '../../utils/ajax';

class UserService {
  conductorUrl = process.env.REACT_APP_CONDUCTOR_ASSETS_URL || '';
  configurationPath = '/networkAsset/airfinder/users';
  deleteConfigurationPath = '/networkAsset/airfinder/user';
  verifyingTokenPath = '/networkAsset/airfinder/user/verificationToken';

  /**
     Create user
     @param {Object} user
     @param {Object} store Redux store
     @returns {Observable} Observable that emits the normalized response
     */
  create = (user, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}`,
        body: UserSerializer.serialize(user),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        responseType: 'json'
      },
      store
    ).pipe(map(data => UserSerializer.normalize(data.response)));
  };

  getAll = (siteId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.configurationPath}?siteId=${siteId}`,
        method: 'GET',
        responseType: 'json'
      },

      store
    ).pipe(map(data => data.response.map(UserSerializer.normalize)));
  };

  deleteSiteUser = (siteUserId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${
          this.deleteConfigurationPath
        }/${siteUserId}`,
        method: 'DELETE',
        responseType: 'json'
      },
      store
    );
  };

  edit = (user, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.deleteConfigurationPath}/${user.id}`,
        body: UserSerializer.serializeEdit(user),
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        responseType: 'json'
      },
      store
    ).pipe(map(data => UserSerializer.normalize(data.response)));
  };

  viewUserLink = (email, siteId, orgId, store) => {
    return ajax(
      {
        url: `${this.conductorUrl}${this.verifyingTokenPath}?email=${email}&siteId=${siteId}&organizationId=${orgId}`,
        headers: { 'Content-Type': 'application/json' },
        method: 'Get',
        responseType: 'json'
      },
      store
    ).pipe(map(data => data.response));
  };
}
export default new UserService();



// WEBPACK FOOTER //
// ./src/services/user/index.js